'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumArrowDown = ({ testId, className })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: jsxRuntime.jsx("path", {
            d: "M3 5.50098L8 10.499L13 5.50195",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

module.exports = MediumArrowDown;
